export const LOST_GROUPS_RIGHT = [
	"Benutzer Zuweisungen",
	"Lizenz Zuweisungen",
	"Rechte Zuweisungen",
];
